import { createContext, useContext } from "react";
import type { PaymentExpectation } from "../types/payment-expectation.types";

interface PaymentExpectationOverviewContextValue {
  expectation: PaymentExpectation | null;
  refetch: () => Promise<void>;
}

const PaymentExpectationOverviewContext =
  createContext<PaymentExpectationOverviewContextValue>({
    expectation: null,
    refetch: async () => {},
  });

export function usePaymentExpectationOverview() {
  return useContext(PaymentExpectationOverviewContext);
}

export default PaymentExpectationOverviewContext;
